<template>
  <v-container>

    <professionals-list />

  </v-container>
</template>

<script>
import ProfessionalsList from '@/components/professionals/ProfessionalsList';

export default {
  data: () => ({}),
  methods: {
    create() {
      this.$router.push('/professionals/cadastre');
    },
  },
  components: {
    ProfessionalsList,
  },
};
</script>
